// extracted by mini-css-extract-plugin
export default {"cls1":"PaperContainer-cls1_J4B","cls2":"PaperContainer-cls2__KI PaperContainer-cls1_J4B"};